import * as types from "../actions/index";
export default function(state = "", action) {
  switch (action.type) {
    case types.SET_ENTITY_NAME:
      return { ...state, ...action.payload };
    // no default
  }
  return state;
}
